<template>
  <div>
    <div>
      <router-view v-if="!loading"/>
      <Loader v-else></Loader>
    </div>
  </div>

</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'

export default {
  computed: mapState([
    'abstract', 'status', 'authors', 'theme_list', 'user', 'submissions'
  ]),
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    '$route.params.id': {
      handler: function (newId, oldId) {
        if (newId && newId !== oldId) {
          this.loadAbstract(newId);
        }
      }
    }
  },
  async created() {
    await this.loadAbstract(this.$route.params.id);
  },
  methods: {
    ...mapActions([
      'GET_USERDATA', 'GET_ONE_ABSTRACT'
    ]),
    ...mapMutations([
      'SET_USER', 'SET_ABSTRACT', 'SET_SETTINGS'
    ]),
    async loadAbstract(id) {
      this.loading = true;
      await this.GET_ONE_ABSTRACT(id).then((response) => {
        this.$store.dispatch('IMPLODE_ADDITIONAL_ABSTRACT_DATA', response.data);
        let submission = this.submissions.find(submission => submission.id === response.data.setting_submission_id);
        this.$store.dispatch('GET_THEME_LIST', submission.themelist_id);
        this.SET_SETTINGS({settings: submission.settings});
      });
      await this.$store.dispatch('GET_AUTHORS', id);
      await this.$store.dispatch('GET_ALL_GENDER');
      await this.$store.dispatch('GET_ALL_SALUTATIONS');
      await this.$store.dispatch('GET_ALL_DATAHELPER');
      if (!this.user || !this.user.id) {
        await this.GET_USERDATA().then((result) => {
          this.SET_USER({user: result.data})
        })
      }
      this.loading = false;
    },
  },
}
</script>

